// extracted by mini-css-extract-plugin
module.exports = {"root":"PageFrame_root__2jxAd","paper":"PageFrame_paper__1N6ir","head":"PageFrame_head__2jNsa","title":"PageFrame_title__1OBdE","actions":"PageFrame_actions__1HgWz"};